import { render, staticRenderFns } from "./AIC_create.vue?vue&type=template&id=37ab16a6&scoped=true&"
import script from "./AIC_create.vue?vue&type=script&lang=js&"
export * from "./AIC_create.vue?vue&type=script&lang=js&"
import style0 from "./AIC_create.vue?vue&type=style&index=0&id=37ab16a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab16a6",
  null
  
)

export default component.exports